import { ActionReducer, INIT } from '@ngrx/store';
import { isPlatformBrowser } from '@angular/common';

export const SIDEBAR_STORAGE_KEY = 'desktop_sidebar_mode';

export function sidebarMetaReducer(
   reducer: ActionReducer<any>
): ActionReducer<any> {
   return (state, action) => {
      // ----- HYDRATE ON APP INIT (BROWSER ONLY) -----
      if (action.type === INIT && typeof window !== 'undefined') {
         const storedMode = localStorage.getItem(SIDEBAR_STORAGE_KEY);

         if (storedMode === 'expanded' || storedMode === 'collapsed') {
            state = {
               ...state,
               sidebar: {
                  ...state?.sidebar,
                  mode: storedMode,
                  isExpanded: storedMode === 'expanded'
               }
            };
         }
      }

      const nextState = reducer(state, action);

      // ----- PERSIST ONLY DESKTOP MODES -----
      if (
         typeof window !== 'undefined' &&
         nextState?.sidebar &&
         (nextState.sidebar.mode === 'expanded' ||
            nextState.sidebar.mode === 'collapsed')
      ) {
         localStorage.setItem(
            SIDEBAR_STORAGE_KEY,
            nextState.sidebar.mode
         );
      }

      return nextState;
   };
}
